<div class="setting-page">
  <div class="calls-quota">
    <legend>Calls Quota</legend>
    <div class="action-buttons">
      <arm-action-bar (addClick)="addCallsQuota()" [disableAdd]="isUnauthorized"
                      (refreshClick)="refresh()"
                      (deleteClick)="deleteCallsQuota()" [disableDelete]="isUnauthorized  || !selection"
                      (editClick)="updateCallsQuota()"  [disableEdit]="isUnauthorized || !selection">

      </arm-action-bar>
    </div>

    <div class="quota-table">
      <arm-table [displayedColumns]="displayedColumns"
                 (onSelection)="onSelection($event)" (pageChanged)="pageChanged($event)"
                 [data]="data.elements" [length]="data.totalElements"
                 [isMultipleSelection]="false"
                 [isClientSide]="false"></arm-table>
    </div>
  </div>

  <calls-quota-configuration [isUnauthorized]="isUnauthorized"></calls-quota-configuration>

</div>
